<ng-original-location-dialog
  *ngIf="(store$ | async) as store"
  [moves]="store.moves"
  [loading]="false"
></ng-original-location-dialog>
